import Dashboard from '../views/dasboard/Dashboard';
import Establishment from '../views/business/Establishment';
import Widget from '../views/widget/Widget';
import Module from '../views/business/Module';
import Prodcuts from '../views/module/maintenance/Products';
import Users from '../views/module/maintenance/Users';
import Business from '../views/module/maintenance/Business/Business';
import Bodegas from '../views/module/maintenance/Bodegas';
import Clients from '../views/module/reports/Clients';
import Catalogos from '../views/module/maintenance/catalogos';
import Earns from '../views/module/reports/Earns';
import Status from '../views/module/reports/Status';
import ForgotPassword from '../auth/login/ForgotPassword'
import ForgotPasswordMobile from '../auth/login/ForgotPasswordMobile'
import ResetPassword from '../auth/login/ResetPassword'
import ResetPasswordMobile from '../auth/login/ResetPasswordMobile'
import OrdenesCompraPendientes from '../views/module/negocio/OrdenesCompraPendientes';
import OrdenesCompraPagadas from '../views/module/negocio/OrdenesCompraPagadas';
import EnvioSeguimiento from '../views/module/negocio/EnvioSeguimiento';
import Perfil from '../views/user/Perfil';
import Templates from '../views/module/templates/Templates'
import Facturacion from '../views/module/facturacion/Facturacion'
import FacturacionHistory from '../views/module/facturacion/FacturacionHistory'
import FacturaTemplate from '../views/module/facturacion/FacturaTemplate'
import '../environments/envionments';

const routes = [

  // credentials 
  { path: global.FORGOTPASSWORD, exact: true, name: 'Dashboard', element: ForgotPassword },
  { path: global.RESETPASSWORD, exact: true, name: 'Dashboard', element: ResetPassword },
  { path: global.FORGOTPASSWORDMOBILE, exact: true, name: 'Dashboard', element: ForgotPasswordMobile },
  { path: global.RESETPASSWORDMOBILE, exact: true, name: 'Dashboard', element: ResetPasswordMobile },

  { path: global.ROUTE_DASHBOARD, exact: true, name: 'Dashboard', element: Dashboard },
  { path: global.ROUTE_ESTABLISHMENTS, exact: true, name: 'Establishment', element: Establishment },
  { path: global.ROUTE_WIDGET, exact: true, name: 'Dashboard', element: Widget },
  { path: global.BUSINESS_MODULE, exact: true, name: 'Empresa Modulos', element: Module },
  { path: global.PERFIL_USER, exact: true, name: 'User Perfil', element: Perfil },

  // services module 
  { path: global.BUSINESS_MODULE_PRODUCTS, exact: true, name: 'Empresa Productos', element: Prodcuts },
  { path: global.BUSINESS_MODULE_USERS, exact: true, name: 'Empresa Users', element: Users },
  { path: global.BUSINESS_MODULE_BUSINESS, exact: true, name: 'Empresa Business', element: Business },
  { path: global.BUSINESS_MODULE_BODEGAS, exact: true, name: 'Empresa Bodega', element: Bodegas },
  { path: global.BUSINESS_MODULE_CATALOGOS, exact: true, name: 'Empresa Catalogos', element: Catalogos },

  // tu negocio module
  { path: global.NEGOCIO_MODULE_ORDENES, exact: true, name: 'Ordenes Compra', element: OrdenesCompraPendientes },
  { path: global.NEGOCIO_MODULE_ORDENES_PAGADAS, exact: true, name: 'Ordenes Compra Pagadas', element: OrdenesCompraPagadas },
  { path: global.NEGOCIO_MODULE_ENVIOSEGUI, exact: true, name: 'Envío seguimiento', element: EnvioSeguimiento },

  // reporteria module
  { path: global.BUSINESS_MODULE_REPORTS, exact: true, name: 'Clientes', element: Clients },
  { path: global.BUSINESS_MODULE_REPORTS_EARN, exact: true, name: 'Ganancias', element: Earns },
  { path: global.BUSINESS_MODULE_REPORTS_STATUS, exact: true, name: 'Estadisticas', element: Status },

  // templates module
  { path: global.BUSINESS_MODULE_TEMPLATES, exact: true, name: 'Templates', element: Templates },

  // Facturacion
  { path: global.BUSINESS_PENDING_INVOICE, exact: true, name: 'Facturacion', element: Facturacion },
  { path: global.BUSINESS_HISTORY_INVOICE, exact: true, name: 'Facturacion History', element: FacturacionHistory },
  { path: global.BUSINESS_INVOICE_TEMPLATE, exact: true, name: 'Facturas', element: FacturaTemplate },

]

export default routes
